export const adaptGrupoObligatorio = (grupoObligatorioData) => {
    return {
        id: grupoObligatorioData?.idGrupoObligatorio,
        displayName: grupoObligatorioData?.descripcion
    }
}

export const adaptGrupoObligatorioArray = (
    grupoObligatorios
) => {
    return structuredClone(grupoObligatorios?.allGrupoObligatorio)
        ?.map(grupoObligatorio => adaptGrupoObligatorio(grupoObligatorio));
}